import React from 'react';
import { LazyImage } from 'project/lazy-image';

const CourseTopPanel = () => {
    return (
        <div className="course__top-panel">
            <div className="ntt-data-logo">
                <LazyImage image="/-/media/Patrons/nttdata-logo-white.png" />
            </div>
        </div>
    );
};

export default CourseTopPanel;
